import React from 'react';

const Timeline = ({ timeheading, journey }) => {
  return (
    <section className="w-full bg-white py-14 md:py-20 px-4 flex flex-col items-center">
      <div className="text-center mb-10 md:mb-12">
        <span className="pl-label">Day by day</span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#8B2218] mt-3">
          {timeheading}
        </h2>
      </div>

      <div className="flex flex-col md:flex-row items-stretch justify-center gap-6 md:gap-8 lg:gap-12 w-full max-w-7xl">
        {journey.map((item, index) => (
          <div
            key={index}
            className="relative flex flex-col text-left p-6 md:p-7 bg-cream rounded-card shadow-soft border border-line w-[90vw] md:w-72 hover:-translate-y-1 hover:shadow-card transition-all duration-300"
          >
            {/* Day badge */}
            <span className="inline-flex self-start items-center px-3 py-1 rounded-pill bg-[#578d48] text-white text-xs font-bold tracking-label uppercase">
              {item.day}
            </span>

            {/* Title */}
            <h4 className="font-heading text-xl md:text-2xl font-bold text-[#E66123] mt-3">
              {item.title}
            </h4>

            {/* Activities */}
            <ul className="mt-4 text-sm md:text-base text-gray-700 space-y-2 text-left w-full">
              {item.activities.map((activity, idx) => (
                <li key={idx} className="flex items-start gap-2 leading-relaxed">
                  {activity}
                </li>
              ))}
            </ul>

            {/* Arrow */}
            {index < journey.length - 1 && (
              <div className="hidden md:block absolute top-1/2 right-[-32px] transform -translate-y-1/2">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#578d48"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M12 5l7 7-7 7"></path>
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Timeline;
